import React from 'react'
import Spinner from "../../atom/loading.spinner.line"
const Index = () => {
    return (
        <div style={{width:'100%', textAlign:'center'}}><Spinner /></div>
    )
}

export default Index
